import React, { Component } from 'react';
import { Page }             from 'moovila-common';
import { Link }             from 'react-router-dom';
import $                    from 'webpack-zepto';

import { Column, Table, WindowScroller }  from 'react-virtualized';

import Masthead               from '../Masthead';
import AddEditEnterprise      from './AddEditEnterprise';
import EnterpriseTunnelModal  from './EnterpriseTunnelModal';
import LicenseAssignment      from '../../containers/Admin/LicenseAssignment';

const yesNoRenderer = ({cellData, rowData}) => {
  const textClass = rowData.isActive ? 'text-center' : 'text-center text-fade';
  const icon = cellData ? <i className='fa fa-check fa-2x' style={{color: '#8b91ff'}}></i> : null;
  return cellData === null ? '' :
    <span className={textClass}>{icon}</span>;
};

let incrementor = 0;

class EnterpriseMaintenanceEnterprises extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDisabled: false,
    }
    this.toggleDisabled = this.toggleDisabled.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.enterpriseGUID && this.props.enterpriseGUID !== nextProps.enterpriseGUID) {
      ++incrementor;
    }
  }

  toggleDisabled() {
    this.setState({
      showDisabled: !this.state.showDisabled,
    });
  }

  render() {
    let { enterprises } = this.props;
    let modal;

    const {
      enterpriseGUID,
      primaryGUID,
      secondaryGUID,
      licenseID,
      method,
      getEnterpriseInfo,
      getEnterpriseRoles,
    } = this.props;

    $('body, html').removeClass('lock-scroll');

    enterprises = this.state.showDisabled ? enterprises : enterprises.filter(enterprise => enterprise.isActive);

    if (method === 'add' || method === 'edit') {
      modal = (
        <AddEditEnterprise
          key={`AddEditEnterprise-${incrementor}`}
          isLoading={this.props.isLoading}
          thereWasAnError={this.props.thereWasAnError}
          enterpriseGUID={enterpriseGUID}
          enterpriseDetail={this.props.enterpriseDetail}
          method={method}
          getEnterpriseInfo={getEnterpriseInfo}
          getEnterpriseRoles={getEnterpriseRoles}
          roles={this.props.roles}
          showMessageBox={this.props.showMessageBox}
          updateEnterpriseDomains={this.props.updateEnterpriseDomains}
          deleteEnterpriseDomain={this.props.deleteEnterpriseDomain}
          addEnterprise={this.props.addEnterprise}
          updateEnterpriseInfo={this.props.updateEnterpriseInfo}
          getDefaultPasswordConfiguration={this.props.getDefaultPasswordConfiguration}
          utilities={this.props.utilities}
          clearEnterpriseInfo={this.props.clearEnterpriseInfo}
          setQuestion={this.props.setQuestion}
          history={this.props.history}
        />
      );
    }

    if (method === 'tunnel') {
      modal = (
        <EnterpriseTunnelModal
          enterpriseGUID={enterpriseGUID}
          enterprises={enterprises}
        />
      );
    }

    if (modal) {
      $('body, html').addClass('lock-scroll');
    }

    if (method === 'license') {
      return (
        <LicenseAssignment
          location={this.props.location}
          type='enterprise'
          enterpriseGUID={enterpriseGUID}
          primaryGUID={primaryGUID}
          secondaryGUID={secondaryGUID}
          licenseID={licenseID}
          context={this.props.context}
          method={this.props.method}
          submethod={this.props.submethod}
        />
      );
    }

    return (
      <div className='EnterpriseMaintenance'>
        <Masthead title='Enterprise Maintenance' icon='fa fa-industry' />
        <div className='EC-sticky-subheader'>
          <div className='row EC-sticky-subheader-inner'>
            <div className='col-xs-10'>
              <Link to='/admin/enterprise-maintenance/enterprises/0/add' className='btn btn-primary btn-xl btn-margin-fix' id='UserMaintenance_btnAddUser'>
                  <i className='fa fa-plus-circle icon' aria-hidden='true'></i>
                  Add enterprise
              </Link>
            </div>
            <div className='col-xs-2'>
              <input
                checked={this.state.showDisabled}
                onChange={this.toggleDisabled}
                className='table-footer__checkbox'
                name='RoleMaintenance_chkFilter'
                id='RoleMaintenance_chkFilter'
                type='checkbox' />
              <label className='table-footer__label table-footer__label--checkbox' htmlFor='RoleMaintenance_chkFilter'>Show disabled</label>
            </div>
          </div>
        </div>
        <Page>
          <section className='section'>
            <WindowScroller>
              {({ height, isScrolling, scrollTop }) => (
              <Table
                className='table-bordered'
                autoHeight
                height={height}
                headerHeight={44}
                isScrolling={isScrolling}
                scrollTop={scrollTop}
                rowCount={enterprises.length}
                rowGetter={({index}) => enterprises[index]}
                rowHeight={52}
                width={992}
              >
                <Column
                  width={150}
                  label='Name'
                  dataKey='enterpriseName'
                  cellRenderer={({cellData, rowData}) => {
                    const textClass = rowData.isActive ? 'ellipsis' : 'ellipsis text-fade';
                    return cellData === null ? '' :
                      <span className={textClass}>{cellData}</span>
                  }}
                />
                <Column
                  width={50}
                  label='Active'
                  dataKey='isActive'
                  cellRenderer={yesNoRenderer}
                />
                <Column
                  width={50}
                  label={<i style={{fontSize: '1.2em', top: 1, position: 'relative'}} className='icon icon-moovila-ec-broadcast'></i>}
                  dataKey='canUseBroadcast'
                  cellRenderer={yesNoRenderer}
                />
                <Column
                  width={50}
                  label={<span><i className='fa fa-image'></i> <i className='fa fa-lock'></i></span>}
                  dataKey='secureImages'
                  cellRenderer={yesNoRenderer}
                />
                <Column
                  width={170}
                  label='Contact Name'
                  dataKey='primaryContactName'
                  cellRenderer={({cellData, rowData}) => {
                    const textClass = rowData.isActive ? 'ellipsis' : 'ellipsis text-fade';
                    return cellData === null ? '' :
                      <span className={textClass}>{cellData}</span>
                  }}
                />
                <Column
                  width={176}
                  label='Email'
                  dataKey='primaryContactEmail'
                  cellRenderer={({cellData, rowData}) => {
                    const textClass = rowData.isActive ? 'ellipsis' : 'ellipsis text-fade';
                    return cellData === null ? '' :
                      <span className={textClass}>{cellData}</span>
                  }}
                />
                <Column
                  width={135}
                  label='Phone'
                  className='text-center'
                  dataKey='primaryContactPhone'
                  cellRenderer={({cellData, rowData}) => {
                    const textClass = rowData.isActive ? 'ellipsis' : 'ellipsis text-fade';
                    return cellData === null ? '' :
                      <span className={textClass}>{cellData}</span>
                  }}
                />
                <Column
                  width={50}
                  label='Admin'
                  dataKey='enterpriseGUID'
                  cellRenderer={({cellData, rowData}) => {
                    return cellData === null ? '' : (
                      <Link to={`/admin/enterprise-maintenance/enterprises/${cellData}/tunnel`} className='btn btn-default btn-block btn-md EnterpriseMaintenance__btn-icon'>
                        <i className='fa fa-magic fa-2x' style={{fontSize: '1.75em'}}></i>
                      </Link>
                    );
                  }}
                />
                <Column
                  width={50}
                  label='Lic.'
                  dataKey='enterpriseGUID'
                  cellRenderer={({cellData, rowData}) => {
                    return cellData === null ? '' : (
                      <Link to={`/admin/enterprise-maintenance/enterprises/${cellData}/license/${cellData}`} className='btn btn-default btn-block btn-md EnterpriseMaintenance__btn-icon'>
                        <i className='fa fa-id-card fa-2x' style={{fontSize: '1.75em', position: 'relative', left: -4, top: -1}}></i>
                      </Link>
                    );
                  }}
                />
                <Column
                  width={50}
                  label='Edit'
                  dataKey='enterpriseGUID'
                  cellRenderer={({cellData, rowData}) => {
                    return cellData === null ? '' : (
                      <Link to={`/admin/enterprise-maintenance/enterprises/${cellData}/edit`} className='btn btn-default btn-block btn-md EnterpriseMaintenance__btn-icon'>
                        <i className='fa fa-pencil-square-o fa-2x'></i>
                      </Link>
                    );
                  }}
                />
                <Column
                  width={50}
                  label='Users'
                  dataKey='enterpriseGUID'
                  cellRenderer={({cellData, rowData}) => {
                    return cellData === null ? '' : (
                      <Link to={`/admin/enterprise-maintenance/users/${cellData}`} className='btn btn-default btn-block btn-md EnterpriseMaintenance__btn-icon'>
                        <i className='fa fa-users' style={{fontSize: '1.5em'}}></i>
                      </Link>
                    );
                  }}
                />
              </Table>
            )}
            </WindowScroller>
          </section>
        </Page>
        { modal }
      </div>
    );
  }
}

export default EnterpriseMaintenanceEnterprises;



// WEBPACK FOOTER //
// ./src/components/Admin/EnterpriseMaintenanceEnterprises.js